module.exports = __webpack_public_path__ + "img/obs_sea_normal.7a7adaa9.svg";